document.addEventListener('alpine:init', () => {
    Alpine.data('lightboxGallery', () => ({
        imageEls: [],
        overlay: null,
        overlayImg: null,
        overlayCaption: null,
        counter: null,
        loader: null,
        index: 0,
        isOpen: false,
        isLoading: false,
        keyHandler: null,
        clickHandler: null,
        touchStartX: 0,
        touchEndX: 0,

        init() {
            this.injectStyles();
            this.refreshImages();
            this.buildOverlay();
            this.clickHandler = (event) => {
                const img = event.target.closest('img');
                if (!img || !this.$el.contains(img)) {
                    return;
                }
                if (img.closest('a')) {
                    return;
                }
                event.preventDefault();
                this.openAtImage(img);
            };
            this.$el.addEventListener('click', this.clickHandler);
        },

        destroy() {
            if (this.clickHandler) {
                this.$el.removeEventListener('click', this.clickHandler);
            }
            if (this.keyHandler) {
                window.removeEventListener('keydown', this.keyHandler);
            }
            if (this.overlay) {
                this.overlay.remove();
            }
            this.overflowHidden = false;
        },

        injectStyles() {
            if (document.getElementById('lightbox-styles')) return;

            const styles = document.createElement('style');
            styles.id = 'lightbox-styles';
            styles.textContent = `
                .lightbox-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0, 0, 0, 0);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                    padding: 16px;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.3s ease, background 0.3s ease, visibility 0.3s;
                    backdrop-filter: blur(0px);
                    -webkit-backdrop-filter: blur(0px);
                }

                .lightbox-overlay.is-open {
                    opacity: 1;
                    visibility: visible;
                    background: rgba(0, 0, 0, 0.92);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                }

                .lightbox-wrapper {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    max-width: 90vw;
                    max-height: 85vh;
                    transform: scale(0.9) translateY(20px);
                    opacity: 0;
                    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s ease;
                }

                .lightbox-overlay.is-open .lightbox-wrapper {
                    transform: scale(1) translateY(0);
                    opacity: 1;
                }

                .lightbox-image-container {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .lightbox-image {
                    max-width: 90vw;
                    max-height: 80vh;
                    width: auto;
                    height: auto;
                    object-fit: contain;
                    border-radius: 4px;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1);
                    transition: opacity 0.3s ease, transform 0.3s ease;
                }

                .lightbox-image.is-loading {
                    opacity: 0.3;
                }

                .lightbox-image.slide-left {
                    animation: slideOutLeft 0.25s ease forwards;
                }

                .lightbox-image.slide-right {
                    animation: slideOutRight 0.25s ease forwards;
                }

                .lightbox-image.slide-in-left {
                    animation: slideInLeft 0.3s ease forwards;
                }

                .lightbox-image.slide-in-right {
                    animation: slideInRight 0.3s ease forwards;
                }

                @keyframes slideOutLeft {
                    to { transform: translateX(-30px); opacity: 0; }
                }

                @keyframes slideOutRight {
                    to { transform: translateX(30px); opacity: 0; }
                }

                @keyframes slideInLeft {
                    from { transform: translateX(30px); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }

                @keyframes slideInRight {
                    from { transform: translateX(-30px); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }

                .lightbox-loader {
                    position: absolute;
                    width: 40px;
                    height: 40px;
                    border: 3px solid rgba(255, 255, 255, 0.2);
                    border-top-color: #fff;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                    opacity: 0;
                    transition: opacity 0.2s;
                }

                .lightbox-loader.is-loading {
                    opacity: 1;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                .lightbox-caption {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 14px;
                    margin-top: 16px;
                    text-align: center;
                    max-width: 600px;
                    line-height: 1.5;
                    opacity: 0;
                    transform: translateY(10px);
                    transition: opacity 0.3s ease 0.1s, transform 0.3s ease 0.1s;
                }

                .lightbox-overlay.is-open .lightbox-caption {
                    opacity: 1;
                    transform: translateY(0);
                }

                .lightbox-counter {
                    position: absolute;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.05em;
                    opacity: 0;
                    transition: opacity 0.3s ease 0.2s;
                }

                .lightbox-overlay.is-open .lightbox-counter {
                    opacity: 1;
                }

                .lightbox-btn {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50px;
                    height: 50px;
                    color: #fff;
                    background: rgba(255, 255, 255, 0.1);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 50%;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                }

                .lightbox-btn:hover {
                    background: rgba(255, 255, 255, 0.2);
                    border-color: rgba(255, 255, 255, 0.4);
                    transform: scale(1.1);
                }

                .lightbox-btn:active {
                    transform: scale(0.95);
                }

                .lightbox-btn:focus-visible {
                    outline: 2px solid #fff;
                    outline-offset: 2px;
                }

                .lightbox-btn svg {
                    width: 24px;
                    height: 24px;
                    stroke-width: 2;
                }

                .lightbox-btn-prev {
                    left: 20px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                .lightbox-btn-prev:hover {
                    transform: translateY(-50%) scale(1.1);
                }

                .lightbox-btn-next {
                    right: 20px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                .lightbox-btn-next:hover {
                    transform: translateY(-50%) scale(1.1);
                }

                .lightbox-btn-close {
                    top: 20px;
                    right: 20px;
                    width: 44px;
                    height: 44px;
                }

                .lightbox-btn-close svg {
                    width: 20px;
                    height: 20px;
                }

                @media (max-width: 768px) {
                    .lightbox-btn-prev,
                    .lightbox-btn-next {
                        width: 44px;
                        height: 44px;
                        bottom: 20px;
                        top: auto;
                        transform: none;
                    }

                    .lightbox-btn-prev {
                        left: 20px;
                    }

                    .lightbox-btn-prev:hover,
                    .lightbox-btn-next:hover {
                        transform: scale(1.1);
                    }

                    .lightbox-btn-next {
                        right: 20px;
                    }

                    .lightbox-image {
                        max-height: 70vh;
                    }

                    .lightbox-caption {
                        font-size: 13px;
                        padding: 0 16px;
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .lightbox-overlay,
                    .lightbox-wrapper,
                    .lightbox-image,
                    .lightbox-caption,
                    .lightbox-counter,
                    .lightbox-btn {
                        transition: none !important;
                        animation: none !important;
                    }
                }
            `;
            document.head.appendChild(styles);
        },

        refreshImages() {
            this.imageEls = Array.from(this.$el.querySelectorAll('img'));
        },

        buildOverlay() {
            if (this.overlay) {
                return;
            }

            const overlay = document.createElement('div');
            overlay.className = 'lightbox-overlay';
            overlay.setAttribute('role', 'dialog');
            overlay.setAttribute('aria-modal', 'true');
            overlay.setAttribute('aria-label', 'Image lightbox');

            // Image container with loader
            const imageContainer = document.createElement('div');
            imageContainer.className = 'lightbox-image-container';

            const img = document.createElement('img');
            img.className = 'lightbox-image';
            img.alt = '';

            const loader = document.createElement('div');
            loader.className = 'lightbox-loader';

            imageContainer.appendChild(img);
            imageContainer.appendChild(loader);

            // Caption
            const caption = document.createElement('div');
            caption.className = 'lightbox-caption';

            // Wrapper
            const wrapper = document.createElement('div');
            wrapper.className = 'lightbox-wrapper';
            wrapper.appendChild(imageContainer);
            wrapper.appendChild(caption);

            // Counter
            const counter = document.createElement('div');
            counter.className = 'lightbox-counter';

            // Navigation buttons with SVG icons
            const prevSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>`;
            const nextSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
            const closeSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;

            const prev = document.createElement('button');
            prev.type = 'button';
            prev.className = 'lightbox-btn lightbox-btn-prev';
            prev.innerHTML = prevSvg;
            prev.setAttribute('aria-label', 'Previous image');

            const next = document.createElement('button');
            next.type = 'button';
            next.className = 'lightbox-btn lightbox-btn-next';
            next.innerHTML = nextSvg;
            next.setAttribute('aria-label', 'Next image');

            const close = document.createElement('button');
            close.type = 'button';
            close.className = 'lightbox-btn lightbox-btn-close';
            close.innerHTML = closeSvg;
            close.setAttribute('aria-label', 'Close lightbox');

            // Event listeners
            prev.addEventListener('click', (event) => {
                event.stopPropagation();
                this.prev();
            });
            next.addEventListener('click', (event) => {
                event.stopPropagation();
                this.next();
            });
            close.addEventListener('click', (event) => {
                event.stopPropagation();
                this.close();
            });

            // Click on overlay background closes
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) {
                    this.close();
                }
            });

            // Touch/swipe support
            overlay.addEventListener('touchstart', (e) => {
                this.touchStartX = e.changedTouches[0].screenX;
            }, { passive: true });

            overlay.addEventListener('touchend', (e) => {
                this.touchEndX = e.changedTouches[0].screenX;
                this.handleSwipe();
            }, { passive: true });

            // Prevent image click from closing
            wrapper.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            overlay.appendChild(wrapper);
            overlay.appendChild(counter);
            overlay.appendChild(prev);
            overlay.appendChild(next);
            overlay.appendChild(close);

            document.body.appendChild(overlay);
            this.overlay = overlay;
            this.overlayImg = img;
            this.overlayCaption = caption;
            this.counter = counter;
            this.loader = loader;

            // Keyboard navigation
            this.keyHandler = (event) => {
                if (!this.isOpen) return;

                switch (event.key) {
                    case 'Escape':
                        this.close();
                        break;
                    case 'ArrowRight':
                        this.next();
                        break;
                    case 'ArrowLeft':
                        this.prev();
                        break;
                }
            };
            window.addEventListener('keydown', this.keyHandler);
        },

        handleSwipe() {
            const diff = this.touchStartX - this.touchEndX;
            const threshold = 50;

            if (Math.abs(diff) > threshold) {
                if (diff > 0) {
                    this.next();
                } else {
                    this.prev();
                }
            }
        },

        openAtImage(img) {
            this.refreshImages();
            const idx = this.imageEls.indexOf(img);
            this.index = idx >= 0 ? idx : 0;
            this.open();
        },

        open() {
            const image = this.imageEls[this.index];
            if (!image || !this.overlay) {
                return;
            }

            this.isOpen = true;
            this.loadImage(image);
            this.updateCounter();

            // Trigger open animation
            requestAnimationFrame(() => {
                this.overlay.classList.add('is-open');
            });

            this.overflowHidden = true;
        },

        loadImage(image, direction = null) {
            const src = image.dataset.lightboxUrl || image.currentSrc || image.src;
            const caption = this.extractCaption(image);

            this.isLoading = true;
            this.loader.classList.add('is-loading');
            this.overlayImg.classList.add('is-loading');

            // Add slide animation class
            if (direction === 'next') {
                this.overlayImg.classList.add('slide-left');
            } else if (direction === 'prev') {
                this.overlayImg.classList.add('slide-right');
            }

            // Preload image
            const preloader = new Image();
            preloader.onload = () => {
                // Remove slide-out animation
                this.overlayImg.classList.remove('slide-left', 'slide-right');

                // Update source
                this.overlayImg.src = src;
                this.overlayImg.alt = caption || '';
                this.overlayCaption.textContent = caption;

                // Add slide-in animation
                if (direction === 'next') {
                    this.overlayImg.classList.add('slide-in-left');
                } else if (direction === 'prev') {
                    this.overlayImg.classList.add('slide-in-right');
                }

                // Remove loading state
                setTimeout(() => {
                    this.isLoading = false;
                    this.loader.classList.remove('is-loading');
                    this.overlayImg.classList.remove('is-loading', 'slide-in-left', 'slide-in-right');
                }, 300);
            };
            preloader.src = src;
        },

        updateCounter() {
            if (this.counter && this.imageEls.length > 1) {
                this.counter.textContent = `${this.index + 1} / ${this.imageEls.length}`;
            } else if (this.counter) {
                this.counter.textContent = '';
            }
        },

        extractCaption(image) {
            const figure = image.closest('figure');
            if (!figure) {
                return image.alt || '';
            }
            const figcaption = figure.querySelector('figcaption');
            return figcaption ? figcaption.textContent.trim() : (image.alt || '');
        },

        close() {
            if (!this.overlay || !this.isOpen) {
                return;
            }

            this.isOpen = false;
            this.overlay.classList.remove('is-open');
            this.overflowHidden = false;
        },

        next() {
            if (!this.imageEls.length || this.isLoading) {
                return;
            }
            this.index = (this.index + 1) % this.imageEls.length;
            this.loadImage(this.imageEls[this.index], 'next');
            this.updateCounter();
        },

        prev() {
            if (!this.imageEls.length || this.isLoading) {
                return;
            }
            this.index = (this.index - 1 + this.imageEls.length) % this.imageEls.length;
            this.loadImage(this.imageEls[this.index], 'prev');
            this.updateCounter();
        },
    }));
});
